import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";
import {BASE_URLS} from "@tci/common";


@Injectable()
export class NgModelerService {

  constructor(private http: Http) { }

  getApiSpecs(): Observable<any> {

    const url = `${BASE_URLS.MODELER}/apis`;
    return this.http.get(url)
            .map((response: Response) => response.json());
  }
}
